module.exports = __webpack_public_path__ + "static/media/icon1.baf8c9db.svg";